import { ApplicationRootState } from 'store/types';
import createDeepEqualSelector from 'utils/create-deep-equal-selector';

// TODO: Move these to a back-office constant file.
const FILTER_NULL = 'null';
const FILTER_NOT_NULL = 'notnull';

const selectRouterUtils = (state: ApplicationRootState) => state.routerUtils;

const selectStoredSearches = createDeepEqualSelector(
  selectRouterUtils,
  (routerUtils) => routerUtils.storedSearches
);

const makeSelectStoredSearch = (pathname: string) =>
  createDeepEqualSelector(
    selectStoredSearches,
    (storedSearches) => storedSearches[pathname] || ''
  );

export {
  FILTER_NULL,
  FILTER_NOT_NULL,
  makeSelectStoredSearch
};
